import { Injectable } from '@nestjs/common';
import { TypesOfLeaves } from './types-of-leaves.entity';
import { TypesOfLeavesDTO } from './dto/types-of-leaves.dto';
import { TypesOfLeavesAdapter } from './dto/types-of-leaves.adapter';
import { TypesOfLeavesResponseModel, AllTypesOfLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { TypeOfLeaveRequest } from './dto/types-of-leaves.request';
import { TypesOfLeavesRepository } from './repo/types-of-leaves.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class TypesOfLeavesService {
    constructor(
      private logService:LogsService,

        private typesOfLeavesRepository: TypesOfLeavesRepository,
        private typesOfLeavesAdapter: TypesOfLeavesAdapter,
    ) { }

    async gettypesOfLeavesWithoutRelations(typeOfLeave: string): Promise<TypesOfLeaves> {
        const typesOfLeavesResponse = await this.typesOfLeavesRepository.findOne({
            where: { typeOfLeave: typeOfLeave },
        });
        if (typesOfLeavesResponse) {
            return typesOfLeavesResponse;
        } else {
            return null;
        }
    }

    async createTypesOfLeaves(typesOfLeavesDTO: TypesOfLeavesDTO, isUpdate: boolean): Promise<TypesOfLeavesResponseModel> {
        try {
            if (!isUpdate) {
                const typesOfLeavesEntity = await this.gettypesOfLeavesWithoutRelations(typesOfLeavesDTO.typeOfLeave);
                if (typesOfLeavesEntity) {
                    throw new ErrorResponse(11104, 'Type Of Leave already exists');
                }
            } else {
                const typesOfLeavesEntity = await this.gettypesOfLeavesWithoutRelations(typesOfLeavesDTO.typeOfLeave);
                if (typesOfLeavesEntity) {
                    if (typesOfLeavesEntity.typeOfLeaveId != typesOfLeavesDTO.typeOfLeaveId) {
                        throw new ErrorResponse(11104, 'Type Of Leave already exists')
                    }
                }
            }
            const convertedEntity: TypesOfLeaves = this.typesOfLeavesAdapter.convertDtoToEntity(typesOfLeavesDTO, isUpdate);
            const savedEntity: TypesOfLeaves = await this.typesOfLeavesRepository.save(convertedEntity);
            const savedDto: TypesOfLeavesDTO = this.typesOfLeavesAdapter.convertEntityToDto(convertedEntity);
            if (savedDto) {
                const response = new TypesOfLeavesResponseModel(true, 1, isUpdate ? 'Type Of Leave Updated Successfully' : 'Type Of Leave Created Successfully');
                const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'TypesOfLeaves', savedDto.typeOfLeaveId, true, '',savedDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Type Of Leave saved but issue while transforming it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }

    async getAllTypesOfLeaves(): Promise<AllTypesOfLeavesResponseModel> {
        try {
            const typesOfLeavesDtos: TypesOfLeavesDTO[] = [];
            const typesOfLeavesEntities: TypesOfLeaves[] = await this.typesOfLeavesRepository.find({ order: { createdAt: 'DESC' } });
            if (typesOfLeavesEntities) {
                typesOfLeavesEntities.forEach(Entity => {
                    const convertedDto: TypesOfLeaves = this.typesOfLeavesAdapter.convertEntityToDto(Entity);
                    typesOfLeavesDtos.push(convertedDto);
                });
                const response = new AllTypesOfLeavesResponseModel(true, 1, 'Types Of Leave Retrieved Successfully', typesOfLeavesDtos);
                
            const newLogDto = new LogsDto(1,'view', 'TypesOfLeaves', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveTypesOfLeaves(): Promise<AllTypesOfLeavesResponseModel> {
        try {
            const typesOfLeavesDtos: TypesOfLeavesDTO[] = [];
            const typesOfLeavesEntities: TypesOfLeaves[] = await this.typesOfLeavesRepository.find({ order: { typeOfLeave: 'ASC' }, where: { isActive: true }, });
            if (typesOfLeavesEntities) {
                typesOfLeavesEntities.forEach(Entity => {
                    const convertedEntity: TypesOfLeaves = this.typesOfLeavesAdapter.convertEntityToDto(Entity);
                    typesOfLeavesDtos.push(convertedEntity);
                });
                const response = new AllTypesOfLeavesResponseModel(true, 11108, 'Active Types Of Leaves Retrieved Successfully', typesOfLeavesDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    
    async getTypesOfLeavesById(typeOfLeaveId: number): Promise<TypesOfLeaves> {
        const response = await this.typesOfLeavesRepository.findOne({
            where: { typeOfLeaveId: typeOfLeaveId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateTypesOfLeave(typesOfLeaveReq: TypeOfLeaveRequest): Promise<TypesOfLeavesResponseModel> {
        try {
            const typesOfLeaveExists = await this.getTypesOfLeavesById(typesOfLeaveReq.typeOfLeaveId);
            if (typesOfLeaveExists) {
                if (typesOfLeaveReq.versionFlag != typesOfLeaveExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current typesOfLeave information. Refresh and try again');
                } else {
                    const typesOfLeaveStatus = await this.typesOfLeavesRepository.update(
                        { typeOfLeaveId: typesOfLeaveReq.typeOfLeaveId },
                        { isActive: typesOfLeaveReq.isActive, updatedUser: typesOfLeaveReq.updatedUser }
                    );
                    if (typesOfLeaveExists.isActive) {
                        if (typesOfLeaveStatus.affected) {
                            const typesOfLeaveResponse: TypesOfLeavesResponseModel = new TypesOfLeavesResponseModel(true, 10115, 'typesOfLeave is de-activated successfully');
                            return typesOfLeaveResponse;
                        } else {
                            throw new ErrorResponse(10111, ' Type Of Leave is already de-activated');
                        }
                    } else {
                        if (typesOfLeaveStatus.affected) {
                            const typesOfLeaveResponse: TypesOfLeavesResponseModel = new TypesOfLeavesResponseModel(true, 10114, 'typesOfLeave is activated successfully');
                            return typesOfLeaveResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Type Of Leave is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}
